// Pure date-range math for the Live Tender Info "latest 7 days, Load More in
// 7-day blocks, never past the start of the relevant month" pagination.
//
// Everything here operates on the IST calendar date (tender_date_time is
// always IST) rather than the viewer's browser timezone or wall-clock "today"
// — the reference point is the LATEST date actually present in the dataset,
// not real-world today, so the page still makes sense when the data is stale.

const IST_TIME_ZONE = 'Asia/Kolkata';

// Extracts the {year, month (1-12), day} an instant falls on, in IST.
export function getISTDateParts(date) {
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: IST_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const parts = Object.fromEntries(fmt.formatToParts(date).map((p) => [p.type, p.value]));
  return { year: Number(parts.year), month: Number(parts.month), day: Number(parts.day) };
}

// India has no DST, so IST is always a fixed +05:30 offset — safe to build directly.
export function istMidnightISO({ year, month, day }) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${year}-${pad(month)}-${pad(day)}T00:00:00+05:30`;
}

export function addDays({ year, month, day }, delta) {
  const d = new Date(Date.UTC(year, month - 1, day));
  d.setUTCDate(d.getUTCDate() + delta);
  return { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate() };
}

function toComparable({ year, month, day }) {
  return year * 10000 + month * 100 + day;
}

export function compareDateParts(a, b) {
  return toComparable(a) - toComparable(b);
}

export function laterOf(a, b) {
  return compareDateParts(a, b) >= 0 ? a : b;
}
